import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useMarkets() {
  const [coins, setCoins] = useState([]);
  const [macro, setMacro] = useState([]);
  const [stocks, setStocks] = useState([]);
  const [updatedAt, setUpdatedAt] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMarkets = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/markets/top`);
      setCoins(data.coins || []);
      setUpdatedAt(data.updated_at || null);
    } catch (e) {
      console.error("markets fetch failed", e);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchMacro = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/markets/macro`);
      setMacro(data.rows || []);
    } catch (e) {
      console.error("macro fetch failed", e);
    }
  }, []);

  const fetchStocks = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/markets/stocks`);
      setStocks(data.rows || []);
    } catch (e) {
      console.error("stocks fetch failed", e);
    }
  }, []);

  useEffect(() => {
    fetchMarkets();
    fetchMacro();
    fetchStocks();
    const t = setInterval(fetchMarkets, 45000);
    const t2 = setInterval(fetchMacro, 300000);
    const t3 = setInterval(fetchStocks, 120000);
    return () => {
      clearInterval(t);
      clearInterval(t2);
      clearInterval(t3);
    };
  }, [fetchMarkets, fetchMacro, fetchStocks]);

  return { coins, macro, stocks, updatedAt, loading };
}
